function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndusind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 425,
    height: 46,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-1.168-5.891h-5.105c.388 1.95.777 4.041 1.218 6.036.09.433.19.876.285 1.359 0 .342.047.682.1 1.023.193 2.383-1.508 2.823-3.156 2.092-.981-.389-1.418-1.068-1.897-1.947-.443-.779-.582-1.506-.783-2.479l-1.265-6.084h-5.059l2.965 14.5c1.558.049 3.111.098 4.672.143-.192-.922-.436-1.799-.582-2.723 1.9 2.287 4.322 3.453 7.15 2.629C.195 7.879.783 5.053.338 2.334.283 1.504.195.777 0 0",
    style: {
      fill: "#98272a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(2.15224 0 0 -2.04605 55.566 32.813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h4.963L.537-21.109h-4.568c.191.779.383 1.554.631 2.339-.928-.88-1.702-1.607-2.725-2.097v3.164c.389.094.783.244 1.119.435 1.465.926 2.039 2.58 2.039 4.235l-.094.826c-.095.775-.433 1.461-1.314 1.846-.48.295-1.166.295-1.75.195v3.748c.289 0 .533-.096.783-.096 1.408-.341 2.619-1.269 3.309-2.677zm-6.125-20.867c-.338-.195-.723-.291-1.17-.385-1.353-.34-2.141-.439-3.549.094-1.65.586-2.474 1.703-3.107 3.211-1.459 3.695.14 8.949 3.74 10.75 1.166.586 2.672.922 4.086.779v-3.748a2.86 2.86 0 0 1-1.117-.387c-.828-.537-1.365-1.314-1.654-2.236-.336-.922-.54-2.238-.243-3.209.094-.488.293-.834.58-1.121.68-.584 1.614-.729 2.434-.584",
    style: {
      fill: "#98272a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(2.15224 0 0 -2.04605 254.14 1.77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-1.02-3.111c-1.408.386-2.435.586-3.89.681-.442 0-.774.049-1.113-.045-1.028-.25-1.467-1.17-.686-1.853.969-.971 2.674-1.211 3.889-1.992.297-.198.634-.489.972-.78.965-1.507.828-3.113-.191-4.673-1.609-2.379-4.67-2.623-7.443-2.428-1.508.101-2.774.39-4.284.681l.93 3.504c1.846-.49 3.016-.929 4.756-.728.785.047 1.91 0 1.91 1.066-.199.78-.926 1.268-1.709 1.606-1.162.535-2.428.875-3.351 1.801-.543.777-.692 1.361-.692 2.333 0 .973.299 1.651.736 2.286C-8.701 1.895-3.592.875 0 0",
    style: {
      fill: "#98272a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(2.15224 0 0 -2.04605 165.373 15.606)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 5.154.096c-.388-1.801-.781-3.6-1.17-5.494-.236-1.217-.724-2.778-.382-3.991.197-.679.429-.924 1.068-1.117.73-.246 1.66-.098 2.242.34 1.746 1.262 2.233 3.357 2.67 5.4l1.07 4.862h5.012l-3.117-14.741c-1.457-.046-2.918.049-4.426 0 .145.831.344 2.047.537 2.874-.537-.489-.971-1.026-1.556-1.461-.727-.582-1.606-.973-2.528-1.217-1.072-.242-2.531-.242-3.553.197-1.121.438-1.945 1.455-2.384 2.578-.582 1.508-.342 2.526-.096 4.086C-1.072-5.061-.533-2.482 0 0",
    style: {
      fill: "#98272a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(2.15224 0 0 -2.04605 103.302 14.902)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h4.963L.49-21.109h-4.574c.195.779.438 1.554.629 2.339-.869-.88-1.695-1.607-2.67-2.097v3.164c.391.094.775.244 1.121.435 1.404.926 1.994 2.58 1.994 4.235l-.056.826c-.094.775-.483 1.461-1.35 1.846-.498.295-1.176.295-1.709.195v3.748c.244 0 .48-.096.775-.096 1.364-.341 2.579-1.269 3.309-2.677zm-6.125-20.867c-.387-.195-.779-.291-1.174-.385-1.353-.34-2.176-.439-3.588.094-1.613.586-2.488 1.703-3.123 3.211-1.414 3.695.207 8.949 3.752 10.75 1.166.586 2.721.922 4.133.779v-3.748a3.153 3.153 0 0 1-1.174-.387 4.334 4.334 0 0 1-1.65-2.236c-.336-.922-.526-2.238-.244-3.209.101-.488.295-.834.629-1.121.689-.584 1.558-.729 2.439-.584",
    style: {
      fill: "#98272a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(2.15224 0 0 -2.04605 90.944 1.77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h5.203L.877-21.062h-5.252",
    style: {
      fill: "#98272a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(2.15224 0 0 -2.04605 11.286 1.77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-1.221-5.891h-5.154c.436 1.95.873 4.041 1.266 6.036.097.433.199.876.343 1.308 0 .393 0 .733.043 1.074.25 2.383-1.562 2.823-3.162 2.092-.924-.437-1.361-1.068-1.845-1.947-.483-.779-.633-1.557-.778-2.479l-1.318-6.084h-4.959l2.871 14.5c1.551.049 3.119.049 4.668.143-.192-.922-.391-1.799-.588-2.723 1.898 2.287 4.332 3.453 7.152 2.629C.143 7.879.729 5.053.34 2.283.24 1.504.143.777 0 0",
    style: {
      fill: "#98272a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(2.15224 0 0 -2.04605 218.98 32.813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h5.254L.928-21.062h-5.26",
    style: {
      fill: "#98272a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(2.15224 0 0 -2.04605 173.956 1.77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-1.213-5.93h-5.156c.389 1.992.877 4.133 1.271 6.08.086.485.188.92.289 1.409 0 .341.041.681.094 1.027.199 2.383-1.555 2.814-3.213 2.09-.924-.395-1.357-1.074-1.886-1.951-.444-.778-.588-1.51-.782-2.479l-1.273-6.131h-5.057l2.924 14.596c1.547.049 3.158.098 4.717.146-.197-.923-.395-1.851-.586-2.726 1.851 2.287 4.379 3.455 7.154 2.678C.197 7.98.732 5.107.344 2.383.291 1.559.146.83 0 0",
    style: {
      fill: "#98272a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(2.15224 0 0 -2.04605 383.526 33.12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h5.105L2.477-12.549l5.16 6.035h5.736L7.348-13.18l3.787-7.978H5.686l-3.35 7.736-1.607-7.736h-5.008",
    style: {
      fill: "#98272a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(2.15224 0 0 -2.04605 396.095 1.77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.438-2.092-.875-4.135-1.271-6.18l-.19-1.65h-4.232l.298 2.236c-.73-.728-1.513-1.361-2.337-1.801v2.53c.044.049.139.049.234.101.543.289.934.483 1.221.778.683.726 1.027 1.841 1.309 2.769h-.725c-.625 0-1.362.045-2.039 0v2.432c1.017.096 2.186.051 3.349.051 0 1.267-.484 2.234-1.797 2.523-.582.1-1.113.1-1.552.1v3.019c3.162.385 6.518-.148 7.685-3.019C.532 2.432.199 1.508 0 0m-7.732-7.395a7.535 7.535 0 0 0-2.483-.728c-1.9-.193-3.891.678-4.717 2.432-.588.974-.435 2.041-.2 3.158.25 1.07.739 1.656 1.993 2.533 1.803.873 3.563 1.168 5.407 1.215v-2.432c-.732-.049-1.461-.246-1.947-.588-.971-.728-1.356-2.09-.294-2.912.633-.437 1.509-.396 2.241-.148zm0 11.284a7.63 7.63 0 0 1-2.043-.244c-.875-.192-1.508-.485-2.34-.87l.584 3.401c1.174.289 2.427.584 3.799.732",
    style: {
      fill: "#98272a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(2.15224 0 0 -2.04605 345.12 29.232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h2.674c2.34 0 5.937-.34 6.609-3.064.149-.438.196-.872.196-1.309v-.053c0-1.599-.772-3.013-2.231-3.99-1.025-.482-1.894-.727-2.916-1.018 2.621-.437 4.33-2.238 3.791-5.109-.785-3.986-4.525-4.615-8.123-4.863v3.5c.193 0 .393.052.537.103 3.012.485 3.69 3.987.828 4.617-.445.1-.875.153-1.365.1v3.115c.584 0 1.217.049 1.748.141 1.609.391 3.744 2.043 1.992 3.894-.73.772-2.476.678-3.74.582Zm-4.863 0H0v-3.354h-.439l-1.024-4.568c.44 0 .981-.049 1.463-.049v-3.115c-.682 0-1.412-.1-2.092-.15l-1.021-4.86c.871.049 2.045.049 3.113.19v-3.5c-.295-.049-.625-.049-.93-.098h-7.875",
    style: {
      fill: "#98272a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(2.15224 0 0 -2.04605 291.416 5.255)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndusind);
export default __webpack_public_path__ + "static/media/indusind.b2977fda81f26b09fcbec89fd4df1265.svg";
export { ForwardRef as ReactComponent };